import { useId } from "react";
import { GardenGround, SkySvgShell, VIEW_HEIGHT, VIEW_WIDTH } from "@/app/components/weather/backgrounds/shared";

/**
 * ClearDaySky — warm golden-blue day sky with sun glow and minimal clouds.
 * Full-viewport illustration; garden silhouettes anchor to the bottom edge.
 */
export function ClearDaySky() {
  const uid = useId().replace(/:/g, "");
  const sky = `${uid}-sky`;
  const sunGlow = `${uid}-sun`;
  const haze = `${uid}-haze`;

  return (
    <SkySvgShell>
      <defs>
        <linearGradient id={sky} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#7EC8E8" />
          <stop offset="30%" stopColor="#A8D8F0" />
          <stop offset="65%" stopColor="#D4ECFA" />
          <stop offset="100%" stopColor="#EEF6FC" />
        </linearGradient>
        <radialGradient id={sunGlow} cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#FFF4C8" stopOpacity="0.95" />
          <stop offset="35%" stopColor="#FFE888" stopOpacity="0.55" />
          <stop offset="70%" stopColor="#FFD860" stopOpacity="0.15" />
          <stop offset="100%" stopColor="#FFC840" stopOpacity="0" />
        </radialGradient>
        <linearGradient id={haze} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#EEF6FC" stopOpacity="0" />
          <stop offset="100%" stopColor="#E8F2F8" stopOpacity="0.85" />
        </linearGradient>
      </defs>

      <rect width={VIEW_WIDTH} height={VIEW_HEIGHT} fill={`url(#${sky})`} />

      <ellipse cx="300" cy="72" rx="120" ry="115" fill={`url(#${sunGlow})`} />
      <circle cx="300" cy="72" r="38" fill="#FFE878" opacity="0.92" />
      <circle cx="300" cy="72" r="32" fill="#FFF0A0" />

      <g fill="#FFFFFF" opacity="0.55">
        <ellipse cx="55" cy="130" rx="48" ry="16" />
        <ellipse cx="28" cy="126" rx="26" ry="12" />
        <ellipse cx="82" cy="126" rx="30" ry="13" />
      </g>

      <rect x="0" y="220" width={VIEW_WIDTH} height={VIEW_HEIGHT - 220} fill={`url(#${haze})`} />

      <GardenGround fill="#1A2838" />
    </SkySvgShell>
  );
}
